import React from "react";

import CalendarNote from "features/itemLists/items/itemTypes/CalendarNote";
import ContinuingCalendarNote from "features/itemLists/items/itemTypes/ContinuingCalendarNote";
import DayHeader from "features/itemLists/items/itemTypes/dayHeaders/DayHeader";
import Appointment from "features/itemLists/items/itemTypes/Appointment";
import Task from "features/itemLists/items/itemTypes/Task";
import NewTask from "features/itemLists/items/itemTypes/NewTask";

import ItemContainerPlatformed from "features/itemLists/items/ItemContainer";

export default function ItemContainerShared(props) {
  function relevantItem() {
    const {
      details,
      dateHelper,
      listType,
      currentTimeInMinutes,
      isToday,
      isDue,
      newTask,
      setNewTask,
      removeEmptyDay,
      setCursorIndex,
    } = props;

    switch (details.type) {
      case "day_name":
        return <DayHeader day_name={details.day_name} />;
      case "calendar_note":
        return <CalendarNote details={details} />;
      case "continuing_calendar_note":
        return <ContinuingCalendarNote details={details} />;
      case "appointment":
        return (
          <Appointment
            details={details}
            dateHelper={dateHelper}
            listType={listType}
            currentTimeInMinutes={currentTimeInMinutes}
            isToday={isToday}
          />
        );
      case "task":
        return (
          <Task
            details={details}
            dateHelper={dateHelper}
            listType={listType}
            currentTimeInMinutes={currentTimeInMinutes}
            isToday={isToday}
            isDue={isDue}
          />
        );
      case "new_task":
        return (
          <NewTask
            {...{
              details,
              newTask,
              setNewTask,
              setCursorIndex,
              removeEmptyDay,
            }}
          />
        );
      default:
        throw new Error(":: Item type unknown");
    }
  }
  return <ItemContainerPlatformed {...props} {...{ relevantItem }} />;
}
